import React from 'react';
import styles from './HeaderWithClose.module.css';

const HeaderWithClose = ({ showClose = true, onClose }) => {
  const handleClose = () => {
    if (typeof window !== 'undefined') {
      window.close();
    }
  };

  return (
    <div className={styles.headerContainer}>
      {showClose && (
        <button
          type="button"
          title="Close Window"
          onClick={onClose || handleClose}
          className={styles.closeButton}
        >
          X
        </button>
      )}
      <a
        className={styles.logo}
        href="https://www.mathrubhumi.com/"
        aria-label="Mathrubhumi"
      >
        <img
          src="https://images.mathrubhumi.com/images/mbi-logo-mobile.svg"
          alt="Mathrubhumi"
        />
      </a>
    </div>
  );
};

export default HeaderWithClose;